/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the NewGenerateRequest interface.
 */
export function instanceOfNewGenerateRequest(value) {
    if (!('action' in value) || value['action'] === undefined)
        return false;
    if (!('userInput' in value) || value['userInput'] === undefined)
        return false;
    return true;
}
export function NewGenerateRequestFromJSON(json) {
    return NewGenerateRequestFromJSONTyped(json, false);
}
export function NewGenerateRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'action': json['action'],
        'clientLocalHour': json['clientLocalHour'] == null ? undefined : json['clientLocalHour'],
        'contextText': json['contextText'] == null ? undefined : json['contextText'],
        'language': json['language'] == null ? undefined : json['language'],
        'retryOf': json['retryOf'] == null ? undefined : json['retryOf'],
        'threadId': json['threadId'] == null ? undefined : json['threadId'],
        'userInput': json['userInput'],
    };
}
export function NewGenerateRequestToJSON(json) {
    return NewGenerateRequestToJSONTyped(json, false);
}
export function NewGenerateRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'action': value['action'],
        'clientLocalHour': value['clientLocalHour'],
        'contextText': value['contextText'],
        'language': value['language'],
        'retryOf': value['retryOf'],
        'threadId': value['threadId'],
        'userInput': value['userInput'],
    };
}
